<template>
  <div>
    <div class="vx-row">
      <vx-card style="min-height: 250px">
        <vs-table
          :max-items="descriptionItems[1]"
          :description="false"
          :data="entities"
          @selected="handleSelected"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div
              style="margin-right: auto; font-size: 1.5rem; font-weight: 550"
            >
              <ul class="heading-ul mb-5">
                <li>
                  <router-link to="/businessEntity" class="vx-row">
                    <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                    {{ $t("entity.label.business_entity_tree_view") }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-menu"
                type="border"
                @click="$router.push('/businessEntity')"
                size="small"
                >{{ $t("entity.label.list_view") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-activity"
                type="border"
                @click="
                  $router.push({ name: 'Business Entity Transaction History' })
                "
                size="small"
                >{{ $t("entity.label.activity_log") }}</vs-button
              >
            </div>
          </template>
        </vs-table>
        <tree-item :node="treedata" class="p-6"></tree-item>
      </vx-card>
    </div>
    <div class="vx-row">
      <vx-card> </vx-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import TreeItem from "./TreeView.vue";
export default {
  data() {
    return {
      descriptionItems: [5, 10, 15],
      treedata: {
        name: "",
        id: 0,
        change: 0,
        children: [],
      },
    };
  },
  components: { "tree-item": TreeItem },
  computed: {
    ...mapState({ entities: (state) => state.entity.list }),
  },
  methods: {
    async getTreeData() {
      this.list_to_tree(this.entities);
    },
    list_to_tree(list) {
      var map = {},
        node,
        roots = [],
        i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i; // initialize the map
        list[i].children = []; // initialize the children
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== undefined) {
          // if you have dangling branches check that map[node.parentId] exists
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      this.treedata = roots[0];
    },
    async getEntityList() {
      try {
        await this.$store.dispatch("entity/setEntities", {});
      } catch (e) {
        console.log("something went to wrong while entities:", e);
      }
    },
  },
  async mounted() {
    await this.getEntityList();
    this.getTreeData();
  },
};
</script>
